export const USER_ACCOUNTS_RESOURCE_PATH = '/v2/security/user/accounts';
export const USER_VKFORGS_RESOURCE_PATH = '/v1/security/user/vkforg/entities';
export const USER_FIRMEN_RESOURCE_PATH = '/v1/security/user/firma/entities';
